import declare from 'dojo/_base/declare';
import lang from 'dojo/_base/lang';
import on from 'dojo/on';
import domConstruct from 'dojo/dom-construct';
import domAttr from 'dojo/dom-attr';
import domClass from 'dojo/dom-class';
import domStyle from 'dojo/dom-style';
import dojoDateLocale from 'dojo/date/locale';
import _WidgetBaseSP from 'more/_WidgetBaseSP';
import HintBox from 'more/HintBox';
import GenericDialog from 'moreCore/UI/GenericDialog/GenericDialog';
import template from './OccurrenceNotesList.html?raw';
export default declare("WidgetCollection.JDM.Occurrence.OccurrenceNotesList", [_WidgetBaseSP], {
        templateString: template,

        occurrenceID: null,
        occurrence: null,
        _notes: [],

        postMixInProperties: function () {
            this.inherited(arguments);
        },
        postCreate: function () {
            this.inherited(arguments);
            this.RequestManager.silentExceptions = true;
        },

        startup: function (entitylist) {
            this.inherited(arguments);

            this.setNewButtonVisibility();

            if (typeof (entitylist) != "undefined") {
                domClass.remove(this.sectionNotes, "w3-hide");
                this._onLoadNotesResponse(entitylist);
            } else {
                this.loadNotes();
            }            
        },

        setNewButtonVisibility: function (bOverrideBoolValue) {
            var actualValue = false;

            if (bOverrideBoolValue === true || bOverrideBoolValue === false) {
                actualValue = bOverrideBoolValue;
            } else if (this.occurrence != null) {
                actualValue = this.occurrence.canCreateNote == true;
            } else {

            }
            
            if (actualValue === true) {
                domClass.remove(this.btnNewNote, "w3-hide");
            } else {
                domClass.add(this.btnNewNote, "w3-hide");
            }

            return actualValue;
        },

        loadNotes: function () {
            domClass.add(this.sectionNotes, "w3-hide");

            this._notes = [];

            this.StandbyStart();

            var url = window.appRoot + "Occurrence/GetNotes";

            if (this.occurrenceID == null || typeof (this.occurrenceID) == "undefined") {
                this.StandbyStop();
                return;
            }

            domClass.remove(this.sectionNotes, "w3-hide");

            this.RequestManager.post(
                url,
                {
                    occurrenceID: this.occurrenceID
                },
                lang.hitch(this, "_onLoadNotesResponse"),
                lang.hitch(this, "_onLoadNotesError"),
                false // sync
            );
        },



        _onLoadNotesResponse: function (notes) {
            this.StandbyStop();

            console.log("Notes loaded", notes);
            if (notes.length > 0) {
                domClass.remove(this.notesContainer, "w3-hide");
            } else {
                if (this.setNewButtonVisibility() === true) {
                    domClass.add(this.notesContainer, "w3-hide");
                } else {
                    domClass.remove(this.notesContainer, "w3-hide");
                    domConstruct.empty(this.notesContainer);
                    domConstruct.create("div", {
                        style: {
                            "fontStyle": "italic"
                        },
                        className: "w3-text-gray",
                        "innerHTML": this.translations["_general__noEntries"]//"keine Einträge"
                    }, this.notesContainer);

                    return;

                }
            }
            
            // employeeTasksContainer
            this.notesTable = new Tabulator(this.notesContainer, {
                data: notes,
                selectableCheck: lang.hitch(this, "tableSelectableCheck"),
                layout: "fitColumns",
                //height: "311px",
                columns: [
                    {
                        title: this.translations["OccurrenceNotesList__TableCol_Date"]/*"Nummer"*/, field: "date_of_message", formatter: lang.hitch(this, "tableFormatterDateTime"), width: 130, editor: false
                    },
                    {
                        title: this.translations["OccurrenceNotesList__TableCol_Author"]/*"Aktionen"*/, field: "ref_employee.DispName", headerSort: false, width:180
                    },
                    {
                        title: this.translations["OccurrenceNotesList__TableCol_Content"]/*"Status"*/, field: "message", editor: false, headerSort: false
                    },
                    

                ],
                //rowFormatter: lang.hitch(this, "_appendNestedTable"),
            });

            domStyle.set(this.notesContainer, "fontSize", "12px");
            
        },

        tableSelectableCheck: function (row) {
            return false;
        },

        //custom formatter definition
        tableBtnActions: function (cell, formatterParams, onRendered) { //plain text value

            var data = cell.getRow().getData();
            var buttonStates = JSON.parse(data.tmp_buttonstates);

            var container = domConstruct.create("div");
            domClass.add(container, "flex_row");
            //console.log("tableBtnActions", data, buttonStates);

            //if (buttonStates.button_accept === true) {
            //    var button = domConstruct.create("div");
            //    domClass.add(button, "w3-padding-small mds-bg-gray mds-hover-dark zal-table-action-button");
            //    domAttr.set(button, "innerHTML", "<i class='fa fa-bolt'>&nbsp;</i>" + this.translations["OccurrenceTaskExecutions__TableBtn_Accept"] /*annehmen"*/);
            //    domAttr.set(button, "title", this.translations["OccurrenceTaskExecutions__TableBtn_AcceptTooltip"]);
            //    domConstruct.place(button, container);
            //    on(button, "click", lang.hitch(this, "_onClick__AcceptTask", data));
            //}
            

            return container;

        },

        tableFormatterDateTime: function (cell, formatterParams, onRendered) {

            var data = cell.getData();
            var value = cell.getValue();

            var date = new Date(value);

            //console.log("tableFormatterDateTime", data);

            if (value == "") {
                return "";
            }

            value = dojoDateLocale.format(date, { locale: 'de-de', datePattern: "dd.MM.yyyy", timePattern: "HH:mm" });

            return value;
        },


        _onLoadNotesError: function (error) {
            this.StandbyStop();
        },


        _onClick_NewNote: function () {
            var dialog = new GenericDialog;

            domStyle.set(dialog.textNode, "height", "unset");
            dialog.destroyOnClose = false;

            dialog.set("header", this.translations["OccurrenceForm__DialogSendNoteHeader"].format(this.occurrence.Number));//taskEntity.Number + " erledigen");
            //dialog.set("SubTitle", "Die Ausführung zu Auftrag " + taskEntity.Number + " wird erledigt und eine Nachricht an den Meldenden geschickt.<br>Möchten Sie eine Anmerkung hinzufügen?");
            dialog.set("SubTitle", this.translations["OccurrenceForm__DialogSendNoteDescription"].format(this.occurrence.Number, this.occurrence.ref_reporter.DispName, this.occurrence.ref_executor_internal.DispName));

            dialog.set("ok", true);
            dialog.set("cancel", true);
            //dialog.set("content", "Hier Freitexteingabe");

            var input = domConstruct.create("textarea");
            domClass.add(input, "w3-input w3-block");
            dialog.addNodeToContent(input);

            dialog.addNodeToContent(this.labelForResponsibleEmployee);

            //domAttr.set(input, "placeholder", this.translations["OccurrenceTaskExecutions__DialogConfirmFinish_NotesPlaceholder"]);//"Anmerkungen?");

            //domAttr.set(input, "value", this.comment); // es sollte ein Standardtext irgendwoher kommen...

            // verhinden dass mit "Enter" der Dialog beendet wird
            on(input, "keyup", function (evt) {
                evt.stopPropagation();
            });

            dialog.set("callback", lang.hitch(this, "_onSendNoteCallback", input, dialog));

            dialog.show();

            //console.log("cell mehrfachauswahl", cell, cellData, options);

            input.style.width = "100%";
        },

        _onSendNoteCallback: function (input, dialog, result) {

            domConstruct.place(this.labelForResponsibleEmployee, this.hiddenContainer);

            if (result != 1) {
                dialog.destroy();
                return;
            }

            this.StandbyStart();

            var note = input.value;
            var data = { message: note, occurrenceID: this.occurrence.ID, isForResponsibleEmployee: this.inputForResponsibleEmployee.checked == true };


            var url = window.appRoot + "Occurrence/SendNote";

            this.RequestManager.post(
                url,
                {
                    jsonData: JSON.stringify(data)
                },
                lang.hitch(this, "_onSendNoteResponse", dialog),
                lang.hitch(this, "_onSendNoteError", dialog),
                false // sync
            );
        },
        _onSendNoteResponse: function (dialog) {

            this.StandbyStop();
            dialog.destroy();

            this.loadNotes();
        },
        _onSendNoteError: function (dialog, error) {
            alert(error.Message);
            this.StandbyStop();

            //domStyle.set(dialog.modalDlg, "display", "block");
            dialog.show();
        },


    });
